import * as React from "react";

import { BlockProps } from "baseui/block";
import { Currency } from "kanopi-components/Currency";
import { DisplayLabel } from "./DisplayLabel";

export type TCurrencyDisplay = {
  answer: string | number | undefined;
} & BlockProps;

export const CurrencyDisplay: React.FC<TCurrencyDisplay> = ({
  answer,
  ...restProps
}) => (
  // TODO: Refactor to use useFormatter() instead of current approach?
  //       https://app.clickup.com/t/1t20hd2
  <Currency value={answer} as={DisplayLabel} {...restProps} />
);
